module.exports = __webpack_public_path__ + "media/Text_quote_center.065d382c.mp4";